import { computed, observable, reaction } from 'mobx';
import MobxState from './MobxState';

class LoadingState extends MobxState {
  hasLoadedOnce = false;

  init() {
    super.init();

    this.loadedReaction_ = reaction(
      () => this.isReady,
      (v) => v && this.handleLoaded()
    );
  }

  get isInitialized() {
    return this.hasLoadedOnce || this.isReady;
  }

  // to be overwritten
  get isReady() {
    return true;
  }

  handleLoaded() {
    this.loadedReaction_?.();
    this.loadedReaction_ = null;
    this.hasLoadedOnce = true;
  }

  destroy() {
    super.destroy();

    this.loadedReaction_?.();
  }
}

LoadingState.annotations = {
  ...MobxState.annotations,
  hasLoadedOnce: observable,
  isReady: computed,
  isInitialized: computed,
};

export default LoadingState;
